import Vue from 'vue'
import Vuex from 'vuex'
Vue.use( Vuex )

//Add import here
import {valueList} from './modules/valueList'
import {config} from './modules/config'
import {client} from './modules/client'

export function createStore () {
    return new Vuex.Store({
        strict: true,
        modules: {
            //Register your store to vuex here
            valueList,
            config,
            client,
        },


        // IMPORTANT: state must be a function so the module can be
        // instantiated multiple times
        state: () => ({
            serverInit: null
        }),
        getters: {
            serverInit: state => state.serverInit,
        },

        mutations: {
            setServerInit (state, value) {
                state.serverInit = value;
            }
        },

        actions: {
            SERVER_INIT({commit}, value) {
                return new Promise((resolve) => {
                    setTimeout(() => {
                        commit('setServerInit', 123);
                        resolve();
                    }, 100);
                });
            }
        }
    })
}


